import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";

export function useProductCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newProduct: { [k: string]: any }) => {
      return (await api.productApi.create(newProduct)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: productQueryKeys.all() });
    },
  });
}
